import SupplierRegisterFields from "../../../lcaSupplier/shared/components/SupplierRegisterFields";
import { IngredientRegisterViewModel } from "../types/ingredientRegisterView.types";
import RegisterFormProvider from "./RegisterFormProvider";

interface NewSupplierFormPanelProps {
  vm: IngredientRegisterViewModel;
}

/**
 * "+ New supplier" sub-form — now the same `SupplierRegisterFields` shared
 * with the LCA Suppliers edit drawer and the legacy ingredient-register
 * flows (`lcaSupplier/shared/components/SupplierRegisterFields.tsx`),
 * matching the Lovable prototype's "Supplier info / Location / Additional"
 * card layout instead of the single flat card this panel used before. Still
 * bound to `controlNewSupplier`/`errorsNewSupplier` from
 * `useSupplierRegisterForm` (one of the 6 protected legacy hooks) so
 * `handleSupplierSave`'s payload stays identical — only the presentation
 * changed. The footer's Save button (`vm.onSave` -> `performSave`) submits
 * this form; no submit button lives in this panel itself, matching before.
 */
const NewSupplierFormPanel = ({ vm }: NewSupplierFormPanelProps) => {
  return (
    <RegisterFormProvider control={vm.controlNewSupplier} errors={vm.errorsNewSupplier}>
      <SupplierRegisterFields
        control={vm.controlNewSupplier}
        country={vm.supplierCountry}
        onCountryChange={vm.onSupplierCountryChange}
        isSupplierAsUser={vm.isSupplierAsUser}
        onIsSupplierAsUserChange={vm.onIsSupplierAsUserChange}
      />
    </RegisterFormProvider>
  );
};

export default NewSupplierFormPanel;
